import { Component, Input, OnChanges, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActionServices, Action } from './model';
declare var $: any;
import { Router } from '@angular/router';
import { Swiper } from 'swiper';
import { CardService } from 'app/components/cards/card.service';

@Component({
  selector: 'app-action-box',
  templateUrl: './action-box.component.html',
  styleUrls: ['./action-box.component.scss']
})
export class ActionBoxComponent implements OnInit, OnChanges {
  mySwiper;
  timeInterval;
  animatedBoxId = '';
  @Input() actionService = new ActionServices('');
  @Output() getMicard: EventEmitter<any> = new EventEmitter();
  @Output() getMotamed: EventEmitter<any> = new EventEmitter();
  hasSlider = false;
  @Output() openBox: EventEmitter<any> = new EventEmitter();


  constructor(private router: Router, private cardService: CardService) { }
  ngOnChanges(): void {
    this.animatedBoxId = this.actionService.animatedBoxId;
    this.hasSlider = this.actionService.hasSlider;
    this.actionService.actions.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
  }
  ngOnInit(): void {
    if (this.hasSlider) {
      setTimeout(() => {
        this.initSlider();
        if (this.actionService.actions.length === 1) {
          this.mySwiper.autoplay = false;
        }
      }, 1000);
    }

  }
  initSlider() {
    this.mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      loop: this.actionService.actions.length > 1,
      noSwiping: this.actionService.actions.length === 1,
      watchOverflow: true,
      centeredSlides: true,
      spaceBetween: 0,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      speed: 700,
      hashNavigation: {
        watchState: true,
      },
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    });
    this.loadScripts();
  }
  openBankBox() {
    this.openBox.emit(this.actionService);
  }
  doAction(action: Action) {
    if (action.disable) {
    } else {
      if (action.title === 'می کارت') {
        this.getMicard.emit();
      } else if (action.title === 'همیار مودی معتمد نما') {
        this.getMotamed.emit();
      } else if (action.newTab) {
        window.open(action.url);
      } else {
        this.router.navigate([action.url]);
      }
    }
  }

  swipSlide() {
    if (this.mySwiper.autoplay) {
      this.mySwiper.autoplay.stop();
    }
    const totalBullets = this.mySwiper.pagination.bullets.length;
    const bullets = document.getElementsByClassName('swiper-pagination-bullet');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < bullets.length; i++) {
      if (bullets[i].classList.contains('swiper-pagination-bullet-active')) {
        bullets[i].classList.remove('swiper-pagination-bullet-active');
      }
    }
    let slideIndex = -1;
    const slides = document.getElementsByClassName('swiper-slide');
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('swiper-slide-active')) {
        slideIndex = i;
      }
    }
    if (this.mySwiper.activeIndex !== slideIndex) {
      this.mySwiper.activeIndex = slideIndex;
      if (this.mySwiper.activeIndex > totalBullets) {
        bullets[0].classList.add('swiper-pagination-bullet-active');
      } else {
        bullets[slideIndex - 1].classList.add('swiper-pagination-bullet-active');
      }
    }
    if (this.mySwiper.autoplay) {
      this.mySwiper.autoplay.start();
    }
  }
  private loadScripts() {
    this.mySwiper.on('touchEnd', () => {
      this.swipSlide();
    });
  }

}
